__turbopack_context__.v({
  "icon": "LocationCell-module___WnCqa__icon",
  "location": "LocationCell-module___WnCqa__location",
  "locationLink": "LocationCell-module___WnCqa__locationLink",
  "tooltipContainer": "LocationCell-module___WnCqa__tooltipContainer",
});
